<template>
    <div>
        <h2 class="site-title">{{ $t('settings.label') }}</h2>
        <v-card v-if="$auth.check('admin') || $auth.check('partner')" class="site-content">
            <my-company></my-company>
        </v-card>
        <v-card v-if="$auth.check('admin')" class="site-content">
            <firmao></firmao>
        </v-card>
        <v-card v-if="$auth.check('admin')" class="site-content">
            <Currency></Currency>
        </v-card>
    </div>
</template>

<script>
    import Firmao from "./settings/Firmao";
    import Currency from "./settings/Currency";
    import MyCompany from "@/components/settings/MyCompany";

    export default {
        components: { Firmao, "my-company": MyCompany, Currency },
        name: "Settings"
    }
</script>

<style scoped>
    .site-content {
        padding: 20px;
    }
</style>
